import classNames from 'classnames';
// import ChatWidget from 'components/common/chat-widget/ChatWidget';
import Footer from 'components/footers/Footer';
// import NavbarDual from 'components/navbars/navbar-dual/NavbarDual';
// import NavbarTopHorizontal from 'components/navbars/navbar-horizontal/NavbarTopHorizontal';
import NavbarTopDefault from 'components/navbars/navbar-top/NavbarTopDefault';
import NavbarVertical from 'components/navbars/navbar-vertical/NavbarVertical';
import { useAppContext } from 'providers/AppProvider';
import { useMainLayoutContext } from 'providers/MainLayoutProvider';
import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';

import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Authentication Guard Component
interface ProtectedRouteProps {
  children: React.ReactNode;
}

interface PermissionRouteProps extends ProtectedRouteProps {
  moduleId: number;
  requiredPermission?: number;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAppContext();
  const location = useLocation();
  const [authState, setAuthState] = useState<{
    isChecking: boolean;
    isAuth: boolean;
  }>({ isChecking: true, isAuth: false });

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const authenticated = await isAuthenticated();
        setAuthState({ isChecking: false, isAuth: authenticated });
      } catch (error) {
        console.error('Auth check failed:', error);
        setAuthState({ isChecking: false, isAuth: false });
      }
    };

    checkAuth();
  }, [isAuthenticated]);

  // Show loading while checking authentication
  if (authState.isChecking) {
    return <div>loading... </div>; // Or your loading component
  }

  // Redirect if not authenticated
  if (!authState.isAuth) {
    const currentPath = location.pathname + location.search;
    const redirectUrl =
      currentPath !== '/' ? encodeURIComponent(currentPath) : '';
    return (
      <Navigate to={redirectUrl ? `/?redirect=${redirectUrl}` : '/'} replace />
    );
    // return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export const PermissionRoute: React.FC<PermissionRouteProps> = ({
  children,
  moduleId,
  requiredPermission
}) => {
  const { hasModulePermission } = useAppContext();

  if (!hasModulePermission(moduleId, requiredPermission)) {
    return <Navigate to="/pages/errors/403" replace />;
  }

  return <>{children}</>;
};

ProtectedRoute.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired
};

PermissionRoute.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired,
  moduleId: PropTypes.number.isRequired,
  requiredPermission: PropTypes.number
};

const MainLayout = () => {
  const {
    config: { navbarPosition }
  } = useAppContext();

  const { contentClass, footerClass } = useMainLayoutContext();

  return (
    <Container fluid className="px-0">
      {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
        <NavbarVertical />
      )}
      {navbarPosition === 'vertical' && <NavbarTopDefault />}
      <div className={classNames(contentClass, 'content')}>
        <ProtectedRoute>
          <Outlet />
          <Footer className={classNames(footerClass, 'position-absolute')} />
        </ProtectedRoute>
      </div>
    </Container>
  );
};

export default MainLayout;
